"use strict";
/*
 * This file is part of the IVMS Online.
 *
 * @copyright 2025 - 2026 © by Rafał Wrzeszcz - Wrzasq.pl.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.api = exports.triggerVesselMutation = exports.loadVesselDashboardQuery = exports.loadVesselStatusPage = exports.listVesselsQuery = exports.meQuery = void 0;
const api_1 = require("aws-amplify/api");
exports.meQuery = `query Me {
    me {
        customer {
            name
            logo
        }
    }
    listVessels {
        vessels {
            vesselId
            name
            label
            embeds { width height title ui { url } }
        }
    }
}
`;
exports.listVesselsQuery = `query ListVessels(
    $pageToken: String
) {
    listVessels(pageToken: $pageToken) {
        vessels {
            vesselId
            name
            label
            status { isOnline }
            actions { sensorId value label }
        }
        pageToken
    }
}
`;
exports.loadVesselStatusPage = `query LoadVesselStatusPage(
    $vesselId: String!
) {
    getVessel(vesselId: $vesselId) {
        vesselId
        name
        label
        status {
            isOnline
            details {
                alarms { id name since acknowledged }
                maintenance { id name dueIn }
                sections {
                    title
                    table { captions }
                    sensors { key title pattern value }
                }
            }
        }
    }
}
`;
exports.loadVesselDashboardQuery = `query LoadVesselDashboard(
    $vesselId: String!
) {
    getVessel(vesselId: $vesselId) {
        vesselId
        name
        label
        status { isOnline }
        embeds { width height title ui { url } }
    }
}
`;
exports.triggerVesselMutation = `mutation TriggerVessel(
    $vesselId: String!
    $sensorId: String!
    $value: String!
) {
    triggerVessel(vesselId: $vesselId, sensorId: $sensorId, value: $value) {
        commandId
        isSuccessful
    }
}
`;
exports.api = (0, api_1.generateClient)();
